
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Award } from 'lucide-react';
import { supabase } from '@/lib/customSupabaseClient';

const CompanyLogos = () => {
  const [logos, setLogos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchLogos();
  }, []);

  const fetchLogos = async () => {
    try {
      const { data, error } = await supabase
        .from('company_logos')
        .select('*')
        .order('order', { ascending: true });

      if (error) throw error;
      setLogos(data || []);
    } catch (error) {
      console.error('Error fetching logos:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 flex justify-center">
          <div className="w-12 h-12 border-4 border-[#0a4b3c] border-t-transparent rounded-full animate-spin"></div>
        </div>
      </section>
    );
  }

  if (logos.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c99b36]/10 text-[#c99b36] rounded-full font-semibold mb-6">
            <Award className="w-4 h-4" />
            <span>Empresas que Confiam</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0a4b3c] mb-6">
            Parceiros de Sucesso
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Orgulhosamente atendendo empresas que confiam em nossa expertise contábil
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8">
          {logos.map((logo, index) => (
            <motion.div
              key={logo.id}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              whileHover={{ scale: 1.05, y: -5 }}
              className="group relative"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-[#0a4b3c]/10 to-[#c99b36]/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <div className="relative bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 p-6 border border-gray-100 backdrop-blur-sm">
                <div className="aspect-square flex items-center justify-center">
                  <img
                    src={logo.logo_url}
                    alt={logo.company_name}
                    className="max-w-full max-h-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-500 transform group-hover:scale-110"
                    loading="lazy"
                  />
                </div>
                <p className="text-center text-sm font-medium text-gray-700 mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {logo.company_name}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyLogos;
